const initialState = {
    refresh: false,
  };
  
  // Action Types
  const TOGGLE_REFRESH = "TOGGLE_REFRESH";
  
  // Reducer
  const refreshReducer = (state = initialState, action) => {
    switch (action.type) {
      case TOGGLE_REFRESH:
        return { ...state, refresh: !state.refresh }; // Toggle refresh
      default:
        return state;
    }
  };
  
  // Action Creator
  export const toggleRefresh = () => ({
    type: TOGGLE_REFRESH,
  });
  
  export default refreshReducer;
  